import type { DispatchReportRangeItemDto } from "@/api/dtos";
import type { DispatchReportRangeItem } from "@/api/report/_models/DispatchReport";
import { toDispatchReportItemFromDto } from "./toDispatchReportItemFromDto";

/** DTO → domain for a combined-range dispatch row, with its source file. */
export const toDispatchReportRangeItemFromDto = (
  dto: DispatchReportRangeItemDto,
): DispatchReportRangeItem => {
  return {
    ...toDispatchReportItemFromDto(dto),
    sourceFile: dto.sourceFile,
  };
};
